import type { AppNavGroup, AppUser } from "@/config/appNav";

export const OWNER_NAV_GROUPS: AppNavGroup[] = [
  {
    items: [{ label: "Dashboard", to: "/proprietaire", icon: "ri-dashboard-3-line" }],
  },
  {
    title: "Gestion",
    items: [
      { label: "Immeubles", to: "/proprietaire/immeubles", icon: "ri-building-2-line", permission: "immeubles.voir" },
      { label: "Biens", to: "/proprietaire/biens", icon: "ri-home-4-line", permission: "biens.voir" },
      { label: "Locataires", to: "/proprietaire/locataires", icon: "ri-user-3-line", permission: "locataires.voir" },
      { label: "Contrats", to: "/proprietaire/contrats", icon: "ri-file-text-line", permission: "contrats.voir" },
    ],
  },
  {
    title: "Finances",
    items: [
      { label: "Loyers", to: "/proprietaire/loyers", icon: "ri-wallet-3-line", permission: "loyers.voir" },
      { label: "Paiements", to: "/proprietaire/paiements", icon: "ri-hand-coin-line", permission: "paiements.voir" },
      { label: "Impayés", to: "/proprietaire/impayes", icon: "ri-alert-line", permission: "impayes.voir" },
      { label: "Dépenses", to: "/proprietaire/depenses", icon: "ri-money-cny-circle-line", permission: "depenses.voir" },
    ],
  },
  {
    title: "Suivi",
    items: [
      { label: "Maintenance", to: "/proprietaire/maintenance", icon: "ri-tools-line", permission: "maintenance.voir" },
      { label: "Documents", to: "/proprietaire/documents", icon: "ri-folder-line", permission: "documents.voir" },
      { label: "Rapports", to: "/proprietaire/rapports", icon: "ri-file-chart-line", permission: "rapports.voir" },
      { label: "Statistiques", to: "/proprietaire/statistiques", icon: "ri-bar-chart-box-line", permission: "statistiques.voir" },
    ],
  },
  {
    title: "Organisation",
    items: [{ label: "Employés", to: "/proprietaire/employes", icon: "ri-team-line", permission: "employes.voir" }],
  },
  {
    title: "Compte",
    items: [
      { label: "Abonnement", to: "/proprietaire/abonnement", icon: "ri-vip-diamond-line", permission: "parametres.voir" },
      { label: "Mes paiements", to: "/proprietaire/mes-paiements", icon: "ri-history-line", permission: "parametres.voir" },
      { label: "Paramètres", to: "/proprietaire/parametres", icon: "ri-settings-3-line", permission: "parametres.voir" },
    ],
  },
];

// Identité de repli neutre : l'espace affiche l'utilisateur réellement connecté.
export const OWNER_USER: AppUser = {
  name: "",
  role: "Propriétaire",
  initials: "",
};

/** Filtre les groupes de navigation de l'espace Propriétaire selon les permissions. */
export function filterOwnerNavGroups(
  groups: AppNavGroup[],
  hasPermission: (permission: string) => boolean
): AppNavGroup[] {
  return groups
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => !item.permission || hasPermission(item.permission)),
    }))
    .filter((group) => group.items.length > 0);
}